import { useEffect, useState } from "react";
import { startOfDay, endOfDay, addDays } from "date-fns";
import { AccountInsightsFilterView } from "../../app/GeneratedApi";
import { usePostAccountInsightsFindFilterQuery } from "../../app/useGeneratedApi";
import { getInitialDateRange } from "../../utils/dateRangeStorage";

export const useDashboard = (
  initialStart: Date = startOfDay(addDays(new Date(), -7)),
  initialEnd: Date = startOfDay(new Date())
) => {
  const getInitialRange = () => {
    const fallbackRange = {
      startDate: initialStart,
      endDate: initialEnd,
    };

    const savedRange = getInitialDateRange(fallbackRange);
    return {
      startDate: startOfDay(savedRange.startDate),
      endDate: endOfDay(savedRange.endDate),
    };
  };

  const [selectedRange, setSelectedRange] = useState(getInitialRange);

  const handleDateChange = ({
    startDate,
    endDate,
  }: {
    startDate: Date;
    endDate: Date;
  }) => {
    setSelectedRange({
      startDate: startOfDay(startDate),
      endDate: endOfDay(endDate),
    });
  };

  return {
    selectedRange,
    handleDateChange,
  };
};

const defaultFilter: AccountInsightsFilterView = {
  accountInsightsTypes: ["CAMPAIGN", "WORKFLOW", "AUDIENCE"],
};

export const useDashboardView = () => {
  const [showDashboard, setShowDashboard] = useState<boolean | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const {
    data,
    isLoading,
    isError,
    error: queryError,
    refetch,
  } = usePostAccountInsightsFindFilterQuery(
    defaultFilter,
    {
      page: 0,
      size: 1,
    },
    {
      enabled: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    setTimeout(() => {
      refetch();
    }, 100);
  }, []);

  useEffect(() => {
    if (isError) {
      setError(queryError as Error);
      setShowDashboard(false);
      return;
    }

    if (data && typeof data.totalElements === "number") {
      setShowDashboard(data.totalElements > 0);
    }
  }, [data, isError, queryError]);

  return {
    loading: isLoading || showDashboard === null,
    showDashboard,
    error,
  };
};
